import { defineMessages } from 'react-intl';

export default defineMessages({
    ratingYourPolicyMessage: {
        id: 'rewrite.eu.Please wait while we rate your policy...',
        defaultMessage: 'Please wait while we rate your policy...'
    }
});
